export const GetReportForNewDairy = (dairyId, reports, viewType, reportType) => {
	return reports.find(report => report.report_dairy_id === dairyId)
}

export const GetMostRecentReport = (dairyId, reportsList) => {
	if(!reportsList){
		return null
	}
	
	for(let i = 0; i < reportsList.length; i++){
		const report = reportsList[i]
		if(report.report_dairy_id === dairyId){
			return report
		}
	}
}